<template>
  <div style="height: 200px; width: 100%;" class="pr-2 pb-2">
    <v-card class="d-flex fill-height" :to="nr===undefined ? undefined : `/team_dashboard/${isodate}/${nr}`">
      <v-card-text style="position: relative;" class="align-self-stretch">
        <!--    -->
        <v-row v-if="loading" style="position: absolute; left: 12px; top:0px; width: 100%; height: 100%;" justify="center" align="center">
          <v-progress-circular indeterminate color="accent" size="64"/>
        </v-row>
        <v-row v-else style="position: absolute; left: 12px; top:0px; bottom: 0; right: 12px" >
          <v-col :cols="12" class="d-flex flex-column justify-space-between" style="position: relative">
            <rocket style="position: absolute; left: 12px; top:56px; width: 80px; height: 80px;" :color="color"></rocket>
            <h6 class="body-1 mt-0 text-no-wrap text-truncate text-center">{{ bereichName }}</h6>
            <v-row class="justify-space-around pt-4 mr-0 ml-0">
              <div style="font-size: 100px; height: 100px;" class="font-weight-light">
                <div class="mt-8">
                  {{index ? Math.round(index) : 0}}
                </div>
              </div>
            </v-row>
            <v-row class="justify-space-around mt-n2 px-5" style="min-height: 22px;">
              <span>{{indexDetails}}</span>
            </v-row>
            <v-row class="mx-3 mb-3" style="background-color: #ebebeb; height: 10px;">
              <div class="d-flex" :style="'background-color: '+color+'; flex-grow: '+((index||0)/100)"></div>
              <div class="d-flex" style=""></div>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import Rocket from "@/components/Rocket";

const {DateTime} = require("luxon");
import {round} from "@/reusable/numbers";
import Bereiche from "@/components/Bereiche";
import Kinds from "@/components/Kinds";
import Activity from "@/components/Activity";

export default {
  name: "TeamBereichWeek",
  components: {Rocket,},
  props: ['bereich', 'date', 'treenode', 'loading', 'nr'],
  data() {
    return {
      index:0,
      isTeam:false,
      indexDetails: undefined,
    }
  },
  methods: {
    getTextStyle(bereich) {
      return { 'color':Bereiche.COLORS_BY_NAME[this.bereich]};
    },
  },
  computed: {
    isodate(){
      return DateTime.fromJSDate(this.date).setLocale("de").toISODate();
    },
    color() {
      return Bereiche.COLORS_BY_NAME[this.bereich];
    },
    bereiche(){
      return Bereiche.NAMES;
    },
    bereichName() {
      return this.$app.getBereichName(this.bereich);
    }
  },
  watch: {
    treenode: {
      deep:true,
      handler(n) {
        if (!n)
          return;
        var b = this.bereich;
        this.title = n.name;
        this.indexDetails=" ";
        if (n.index!==undefined) {
          this.isTeam=false;
          this.index = n.index[b] || 0;
        } else if (n.teamIndex!==undefined) {
          this.isTeam=true;
          var eigen=Math.round(n.teamIndex["own/"+b] || 0);
          var team=Math.round(n.teamIndex["team/"+b] || 0);
          var total=Math.round(n.teamIndex["total/"+b] || 0);
          this.index = total;
          this.indexDetails= `Eigen: ${eigen}  Team: ${team}`
        } else {
          this.isTeam=false;
          this.index = 0;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>